(function($){
  $(document).ready(function() {

    $('.recherche_link').on('click', function(e){
        e.preventDefault();
        $('#formchercher').toggleClass('open').find('input[name="s"]').focus();
        $('.masque').show().toggleClass('masque-recherche');
    });

  })
})(jQuery);
